<app-btn-calcula-indice-ajuste-periodo-contrato *appRole="['IndicesAjusteContrato.Calcular']" (procesoFinalizado)="procesoFinalizado($event)"></app-btn-calcula-indice-ajuste-periodo-contrato>
<br>
<br>
<div class="alert alert-info alert-dismissible">
    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
    <strong>Info!</strong> Este proceso realiza la actualizacion de los importes de los periodos de los contratos. Luego genera los nuevos importes para los periodos posteriores.
</div>

<app-listado-periodos-historicos *appRole="['IndicesAjusteContrato.Ver']" [procesado]="procesado"></app-listado-periodos-historicos>
